export const paymentStatusText = {
  SUCCESS: 'success',
  FAIL: 'failed',
};

export const PAYMENT_TYPE_TEXT = {
  PLAN: 'plan',
  REGISTER: 'register',
};

export enum PAYMENT_TYPE {
  RECURRING = 'recurring',
  SUBSCRIPTION = 'subscription',
}
